import { intersection, mesh, redoPattern, object } from './webGL.js';

const THREE = window.THREE;

window.patternScale = function (scale) {
  let _scale = (scale + 50) / 100;
  if (this.intersection.mesh != null) {
    this.intersection.mesh.material.map.repeat.set(_scale, _scale);
  } else {
    mesh.forEach((m) => {
      m.material.map.repeat.set(_scale, _scale);
    });
  }
};

export function addPattern(pattern) {
  const textureloader = new THREE.TextureLoader();
  textureloader.crossOrigin = 'Anonymous';
  var temp = textureloader.load(pattern.Thumbnail + '?not-from-cache-please');
  temp.wrapS = temp.wrapT = THREE.RepeatWrapping;
  temp.repeat.set(8, 8);

  var _value = {
    map: temp,
    patternFile: pattern.file,
    updatedTexture: pattern.Thumbnail,
  };
  var _currentValue = {
    map: intersection.mesh.material.map,
    patternFile: intersection.mesh.patternFile,
    updatedTexture: intersection.mesh.updatedTexture,
  };

  if (pattern) {
    var action = {
      type: 'pattern',
      uuid: intersection.mesh.uuid,
      mesh: intersection.mesh,
      value: _value,
      currentValue: _currentValue,
      id: intersection?.mesh?.id,
    };

    window.undoPatterns.push(action);
    intersection.mesh.material.map = temp;
    intersection.mesh.patternFile = pattern.file;
    intersection.mesh.updatedTexture = pattern.Thumbnail;
    intersection.mesh.material.needsUpdate = true;

    // window.currentLogo = null;
  }
  redoPattern && (redoPattern.length = 0);
  //updateProduct();
}

export function doUndoPattern() {
  if (window.undoPatterns.length > 0) {
    var lastAction = window.undoPatterns.pop();
    lastAction.mesh.material.map = lastAction.currentValue.map;
    lastAction.mesh.patternFile = lastAction.currentValue.patternFile;
    lastAction.mesh.updatedTexture = lastAction.currentValue.updatedTexture;
    lastAction.mesh.material.needsUpdate = true;
    redoPattern.push(lastAction);
  }
}

export function doRedoPattern() {
  if (redoPattern.length > 0) {
    var lastAction = redoPattern.pop();
    lastAction.mesh.material.map = lastAction.value.map;
    lastAction.mesh.patternFile = lastAction.value.patternFile;
    lastAction.mesh.updatedTexture = lastAction.value.updatedTexture;
    lastAction.mesh.material.needsUpdate = true;
    window.undoPatterns.push(lastAction);
  }
}

export function clearAllPattern() {
  const THREE = window.THREE;
  
  // Restore all meshes to current style texture
  if (window.currentStyle && window.currentStyle.main_texture) {
    const textureLoader = new THREE.TextureLoader();
    textureLoader.crossOrigin = 'Anonymous';
    
    const styleTexture = textureLoader.load(
      window.currentStyle.main_texture + '?not-from-cache-please',
      () => {
        // Texture loaded successfully
        if (mesh?.length > 0) {
          for (let i = 0; i < mesh.length; i++) {
            // Restore to style texture for all meshes
            styleTexture.wrapS = styleTexture.wrapT = THREE.RepeatWrapping;
            styleTexture.repeat.set(window.currentStyle.Scale || 1, window.currentStyle.Scale || 1);
            mesh[i].material.map = styleTexture;
            mesh[i].material.needsUpdate = true;
            mesh[i].patternFile = null;
            mesh[i].updatedTexture = null;
            // Keep mapOrigin for future pattern applications
            if (mesh[i].mapOrigin == null) {
              mesh[i].mapOrigin = styleTexture;
            }
          }
        }
      },
      undefined,
      (error) => {
        console.error('Error loading style texture for pattern reset:', error);
        // Fallback: restore to mapOrigin if available
        if (mesh?.length > 0) {
          for (let i = 0; i < mesh.length; i++) {
            if (mesh[i].mapOrigin != null) {
              mesh[i].material.map = mesh[i].mapOrigin;
            }
            mesh[i].material.needsUpdate = true;
            mesh[i].patternFile = null;
            mesh[i].updatedTexture = null;
          }
        }
      }
    );
  } else {
    // Fallback: restore to mapOrigin if available, otherwise keep current
    if (mesh?.length > 0) {
      for (let i = 0; i < mesh.length; i++) {
        if (mesh[i].mapOrigin != null) {
          mesh[i].material.map = mesh[i].mapOrigin;
        }
        mesh[i].material.needsUpdate = true;
        mesh[i].patternFile = null;
        mesh[i].updatedTexture = null;
      }
    }
  }
  
  // Clear undo/redo history
  window.undoPatterns && (window.undoPatterns.length = 0);
  redoPattern && (redoPattern.length = 0);
}

export function clearPatternOnly() {
  // Clear only pattern, keep style and other features
  clearAllPattern();
  // Keep window.currentPattern so user can apply pattern again
  // window.currentPattern is already set by patternHandling.selectedPattern()
}

class PatternHandling {
  constructor() {}

  selectedPattern(pattern) {
    window.currentPattern = pattern;
  }

  updatePattern(pattern, intersection) {
    if (intersection.mesh.mapOrigin == null) {
      intersection.mesh.mapOrigin = intersection.mesh.material.map;
    }
    console.log(pattern);

    addPattern(pattern, intersection);
  }
}

export var patternHandling = new PatternHandling();

